import { MenuList, Stack, styled } from '@mui/material';

export interface SidebarStyledProps {
  isCollapsed?: boolean;
}

export const SIDEBAR_COLLAPSED_STORAGE_KEY = '@schooly:sidebar-collapsed';

export const SIDEBAR_WIDTH = 200;
export const SIDEBAR_WIDTH_COLLAPSED = 60;

export const SidebarStyled = styled(Stack)<SidebarStyledProps>(({ theme, isCollapsed }) => ({
  position: 'fixed',
  left: 0,
  top: 'var(--trial-banner-height, 0px)',
  transition: 'width .2s ease',
  width: isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH,
  height: 'calc(100% - var(--trial-banner-height, 0px))',
  background: theme.palette.background.default,
  borderRight: theme.mixins.borderValue(),
  padding: theme.spacing(2.5, 0, 1.5),
  overflow: 'auto',
}));

export const SidebarMenuList = styled(MenuList)(({ theme }) => ({
  '& .MuiMenuItem-root': {
    ...theme.typography.h3,
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.primary,
    textWrap: 'wrap',

    '&:hover, &.Mui-selected': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.common.light2,
    },

    '& .MuiListItemIcon-root': {
      marginRight: theme.spacing(),
      width: theme.spacing(2.5),
      minWidth: theme.spacing(2.5),
      fontSize: theme.spacing(2.5),
      color: 'inherit',
    },
  },
}));
